import elementService from "@/common/ElementService";
import { assert } from "@/common/assert";

declare global {
    interface Window {
        amioWebchat?: {

            /**
             * @param config
             */
            init: (config: AmioWebchatConfig) => void;

            /**
             * @param message Objekt zprávy.
             */
            sendMessage: (message: AmioMessage) => void;

            open: () => void;
        };
    }
}

interface AmioWebchatConfig {
    channelId: string;
    accessToken?: string;
    startOpened?: boolean;
    hideLauncher?: string;
    hideCloseButton?: boolean;
    hideHeader?: boolean;
    theme?: string;
    lang: string;
    iframeOffsetX?: number;
    forceFullScreen?: boolean;
    zIndex: number;
    logoUrl?: string;

    onMessage?: (message: string) => void;
}

interface AmioMessage {
    text: string;
}

export default class AmioChatPageService {
    private static readonly ACCESS_TOKEN = "hxdMdF2tiGPoJMh5hdoYFHchJCm8Mk1gDzFViZMbeO6ONCji8j1wRdQDqJYe9fef9TD5BVAjrKLSyY7eNAkWrUq2iw";
    private static readonly CHANNEL_ID = "7265306200341499429";
    private static readonly SCRIPT_URL = "https://chat-widget.static-amio.com/static/amio-webchat-loader.min.js";

    constructor() {
        this.loadExternalScript(AmioChatPageService.SCRIPT_URL)
            .then(() => {
                if (!window.amioWebchat || typeof window.amioWebchat.init !== "function") {
                    throw new Error("amioWebchat není dostupný i po načtení skriptu.");
                }

                window.amioWebchat.init({
                    channelId: AmioChatPageService.CHANNEL_ID,
                    accessToken: AmioChatPageService.ACCESS_TOKEN,
                    onMessage: this.handleIncomingMessage.bind(this),
                    lang: "cs",
                    startOpened: false,
                    forceFullScreen: true,
                    zIndex: 10_000,
                    theme: "odkarla",
                    logoUrl: "https://cdn.odkarla.cz/css/image/karel_desktop.png",
                    hideLauncher: "always",
                });
            })
            .catch(() => {
                throw new Error("Chyba při načítání externího skriptu:");
            });
    }

    public init(): void {
        const buttonAmioChat = elementService.querySelector<HTMLButtonElement>("#btnAmioChat");
        buttonAmioChat.addEventListener("click", function() {
            assert(window.amioWebchat !== undefined);
            window.amioWebchat.open();
        });
    }

    /**
     * @param text Text zprávy, kterou chceme odeslat.
     */
    public sendMessage(text: string): void {
        if (!window.amioWebchat || typeof window.amioWebchat.sendMessage !== "function") {
            throw new Error("Metoda amioWebchat.sendMessage není dostupná.");
        }

        const message: AmioMessage = {
            text: text,
            // v případě potřeby lze rozšířit o další vlastnosti dle:
            // https://docs.amio.io/docs/amio-chat-getting-started-web-chat-send-message-through-amio-api
        };

        window.amioWebchat.sendMessage(message);
    }

    /**
     * @param source URL skriptu
     */
    private loadExternalScript(source: string): Promise<void> {
        return new Promise((resolve, reject) => {
            // Pokud už je skript načtený, okamžitě resolve
            if (document.querySelector<HTMLScriptElement>(`script[src="${source}"]`)) {
                resolve();

                return;
            }

            const script: HTMLScriptElement = document.createElement("script");
            script.src = source;
            script.type = "text/javascript";
            script.async = true;

            script.addEventListener("load", () => {
                resolve();
            });

            script.addEventListener("error", () => {
                reject(new Error(`Nepodařilo se načíst skript ${source}`));
            });

            document.head.appendChild(script);
        });
    }

    private handleIncomingMessage(): void {
        // console.log("Přijata zpráva od Amio:");
    }
}
